// extracted by mini-css-extract-plugin
export default {"highlight":"aAZVPktLIACpl8KCrhY7","active":"ahLfazzmbHKWnDDwgZA2","animate":"YHZDaYSdEwilPANMC9nl","animation":"NRm5XxZpnpHg6rbkKUnw"};